export default __webpack_public_path__ + "static/media/gif.20b54461.svg";